﻿import { complementOf } from "../../utils/percentage.js";

export const initChangeBankAccountPage = () => {
    const iban1PercentageInput = document.querySelector('[data-role="iban1-percentage"]');
    const iban2PercentageInput = document.querySelector('[data-role="iban2-percentage"]');
    const iban2Block = document.querySelector('[data-role="iban2-block"]');
    const iban1AndAndCheck = document.querySelector('[data-role="iban1-and-and-check"]');
    const iban2AndAndCheck = document.querySelector('[data-role="iban2-and-and-check"]');
    const iban1Name2Block = document.querySelector('[data-role="iban1-name2-block"]');
    const iban2Name2Block = document.querySelector('[data-role="iban2-name2-block"]');
    const ibanSignedAllItem = document.querySelector('[data-role="iban-signed-all-item"]');
    const iban1Name1Input = document.querySelector('[data-role="iban1-name1"]');
    const iban2Name1Input = document.querySelector('[data-role="iban2-name1"]');
    const copyIdApplicant2Item = document.querySelector('[data-item-role="copy-id-applicant2-item"]');
    const uploadIban1AndAndInput = document.querySelector('[data-role="upload-iban1-and-and"]');
    const uploadIban2AndAndInput = document.querySelector('[data-role="upload-iban2-and-and"]');
    const uploadIban1PercentageInput = document.querySelector('[data-role="upload-iban1-percentage"]');
    const uploadIban1Name1Input = document.querySelector('[data-role="upload-iban1-name1"]');
    const uploadIban2Name1Input = document.querySelector('[data-role="upload-iban2-name1"]');

    const downloadSepaBtn = document.querySelector('[data-role="download-sepa-btn"]');
    const downloadSepaForm = document.querySelector('[data-role="download-bank-account-sepa-form"]');

    const bankAccountDocumentsUploadBtn = document.querySelector('[data-role="bank-account-documents-btn"]');
    const bankAccountDocumentsUploadForm = document.querySelector('[data-role="bank-account-documents-form"]');

    const requiredUploadItems = Array.from(
        document.querySelectorAll('[data-role="sepa-upload-item"][data-required="true"]')
    );

    const blockDecimalInput = (event) => {
        if (event?.key === '.' || event?.key === ',' || event?.code === 'NumpadDecimal' || event?.data === '.' || event?.data === ',') {
            event.preventDefault();
        }
    };

    const sanitizePercentageInput = (input) => {
        if (!input) return;

        const raw = (input.value ?? '').toString().trim();
        if (raw === '') return;

        const normalizedRaw = raw.replace(/[.,]/g, '');
        const numericRaw = normalizedRaw.replace(/\D/g, '');

        if (numericRaw === '') {
            input.value = '';
            return;
        }

        let value = Number(numericRaw);

        if (!Number.isFinite(value)) {
            input.value = '';
            return;
        }

        if (value < 0) value = 0;
        if (value > 100) value = 100;

        input.value = String(value);
    };

    const handlePercentagePaste = (input) => (event) => {
        const pasted = event.clipboardData?.getData('text') ?? '';
        if (/[.,]/.test(pasted)) {
            event.preventDefault();
            const cleaned = pasted.replace(/[.,]/g, '');
            const start = input.selectionStart ?? input.value.length;
            const end = input.selectionEnd ?? input.value.length;

            if (typeof input.setRangeText === 'function') {
                input.setRangeText(cleaned, start, end, 'end');
                input.dispatchEvent(new Event('input', { bubbles: true }));
            } else {
                input.value = `${input.value.slice(0, start)}${cleaned}${input.value.slice(end)}`;
                input.dispatchEvent(new Event('input', { bubbles: true }));
            }
        }
    };

    const updateIban2Visibility = () => {
        const iban1Value = Number(iban1PercentageInput.value);
        const showIban2 = iban1Value > 0 && iban1Value < 100;

        iban2Block.hidden = !showIban2;
    };

    const updatePercentages = (event) => {
        const role = event.target.getAttribute('data-role');

        if (role === 'iban1-percentage') {
            iban2PercentageInput.value = complementOf(iban1PercentageInput.value);
            return;
        }

        if (role === 'iban2-percentage') {
            const iban2Value = Number(iban2PercentageInput.value);

            if (iban2Value === 100) {
                iban1PercentageInput.value = 100;
                updateIban2Visibility();
                iban2PercentageInput.value = 0;
                return;
            }

            if (iban2Value === 0 && iban2PercentageInput.value.trim() !== '') {
                iban1PercentageInput.value = 100;
                updateIban2Visibility();
                return;
            }

            iban1PercentageInput.value = complementOf(iban2Value);
        }
    };

    const toggleBlockVisibility = (block, isVisible) => {
        if (!block) return;
        block.hidden = !isVisible;
    };

    const handleIban1AndAndListener = (event) => {
        toggleBlockVisibility(iban1Name2Block, event.target.checked);
        updateSignedAllVisibility();
        updateSecondApplicantUploadItemVisibility();
    };
    const handleIban2AndAndListener = (event) => {
        toggleBlockVisibility(iban2Name2Block, event.target.checked);
        updateSignedAllVisibility();
        updateSecondApplicantUploadItemVisibility();
    };

    const updateSignedAllVisibility = () => {
        const anyChecked = Boolean(iban1AndAndCheck?.checked || iban2AndAndCheck?.checked);
        toggleBlockVisibility(ibanSignedAllItem, anyChecked);
    };

    const updateSecondApplicantUploadItemVisibility = () => {
        const iban1Name1 = (iban1Name1Input?.value ?? '').trim();
        const iban2Name1 = (iban2Name1Input?.value ?? '').trim();
        const hasSecondAccount = Number(iban1PercentageInput?.value ?? '100') > 0 && Number(iban1PercentageInput?.value ?? '100') < 100;
        const namesDiffer = iban1Name1.length > 0 && iban2Name1.length > 0 && iban1Name1.localeCompare(iban2Name1, undefined, { sensitivity: 'accent' }) !== 0;
        const hasSecondAccountHolder = Boolean(iban1AndAndCheck?.checked || iban2AndAndCheck?.checked);
        const showSecondApplicantUpload = hasSecondAccountHolder || (hasSecondAccount && namesDiffer);

        if (uploadIban1AndAndInput) {
            uploadIban1AndAndInput.value = String(Boolean(iban1AndAndCheck?.checked));
        }

        if (uploadIban2AndAndInput) {
            uploadIban2AndAndInput.value = String(Boolean(iban2AndAndCheck?.checked));
        }

        if (uploadIban1PercentageInput) {
            uploadIban1PercentageInput.value = iban1PercentageInput?.value ?? '100';
        }

        if (uploadIban1Name1Input) {
            uploadIban1Name1Input.value = iban1Name1;
        }

        if (uploadIban2Name1Input) {
            uploadIban2Name1Input.value = iban2Name1;
        }

        toggleBlockVisibility(copyIdApplicant2Item, showSecondApplicantUpload);
    };

    const handleIban1PercentageInputListeners = (event) => {
        sanitizePercentageInput(iban1PercentageInput);
        updateIban2Visibility();
        updatePercentages(event);
        updateSecondApplicantUploadItemVisibility();
    };

    const allRequiredFilesUploaded = () =>
        requiredUploadItems.every(item =>
            Array.from(item.querySelectorAll('input[data-upload-hidden]'))
                .some(input => input.value && input.value.trim() !== '')
        );

    const updateUploadButton = () => {
        if (!bankAccountDocumentsUploadBtn) return;

        if (allRequiredFilesUploaded()) {
            bankAccountDocumentsUploadBtn.removeAttribute('disabled');
            bankAccountDocumentsUploadBtn.setAttribute('aria-disabled', 'false');
        } else {
            bankAccountDocumentsUploadBtn.setAttribute('disabled', 'disabled');
            bankAccountDocumentsUploadBtn.setAttribute('aria-disabled', 'true');

        }
    };

    const setDownloadingSepaState = (isSubmitting) => {
        if (downloadSepaForm) downloadSepaForm.setAttribute('aria-busy', String(isSubmitting));

        if (!downloadSepaBtn) return;

        if (isSubmitting) {
            downloadSepaBtn.setAttribute('disabled', 'disabled');
            downloadSepaBtn.setAttribute('aria-disabled', 'true');
            downloadSepaBtn.classList.add('loading');
            downloadSepaBtn.dataset.originalLabel ??= downloadSepaBtn.textContent.trim();
        } else {
            downloadSepaBtn.removeAttribute('disabled');
            downloadSepaBtn.removeAttribute('aria-disabled');
            downloadSepaBtn.classList.remove('loading');
            if (downloadSepaBtn.dataset.originalLabel) {
                downloadSepaBtn.textContent = downloadSepaBtn.dataset.originalLabel;
            }
        }
    }

    const handleDownloadSepaSubmit = (event) => {
        // If another listener (e.g. a future validator) cancelled the submit,
        // don't lock the button into a loading state with no submit to follow.
        if (event?.defaultPrevented) return;

        setDownloadingSepaState(true);
        // The browser navigation does not unload the page for a file download,
        // so reset the loading state after a short timeout as a fallback.
        window.setTimeout(() => setDownloadingSepaState(false), 8000);
    };

    const setSubmittingState = (isSubmitting) => {
        if (bankAccountDocumentsUploadForm) bankAccountDocumentsUploadForm.setAttribute('aria-busy', String(isSubmitting));

        if (!bankAccountDocumentsUploadBtn) return;

        if (isSubmitting) {
            bankAccountDocumentsUploadBtn.setAttribute('disabled', 'disabled');
            bankAccountDocumentsUploadBtn.setAttribute('aria-disabled', 'true');
            bankAccountDocumentsUploadBtn.classList.add('loading');
            bankAccountDocumentsUploadBtn.dataset.originalLabel ??= bankAccountDocumentsUploadBtn.textContent.trim();
        } else {
            bankAccountDocumentsUploadBtn.removeAttribute('disabled');
            bankAccountDocumentsUploadBtn.removeAttribute('aria-disabled');
            bankAccountDocumentsUploadBtn.classList.remove('loading');
            if (bankAccountDocumentsUploadBtn.dataset.originalLabel) {
                bankAccountDocumentsUploadBtn.textContent = bankAccountDocumentsUploadBtn.dataset.originalLabel;
            }
        }
    };

    const resetUploadSubmitState = (form) => {
        form.dataset.submitInProgress = 'false';
        setSubmittingState(false);
        updateUploadButton();
    };

    function handleSepaUploadBeforeSubmit(event) {
        event.preventDefault();

        const form = event.currentTarget;
        if (!(form instanceof HTMLFormElement)) {
            return;
        }

        if (form.dataset.submitInProgress === 'true') {
            return;
        }

        form.dataset.submitInProgress = 'true';
        submitSepaUploadForm(form);
    }

    async function submitSepaUploadForm(form) {
        setSubmittingState(true);

        try {
            const response = await fetch(form.action, {
                method: 'POST',
                body: new FormData(form),
                credentials: 'same-origin',
                redirect: 'manual'
            });

            if (response.type === 'opaqueredirect' || response.status === 0) {
                window.location.assign(form.dataset.successUrl);
                return;
            }

            if (!response.ok) {
                resetUploadSubmitState(form);
                return;
            }

            console.warn('Unexpected non-redirect success response', response);
            resetUploadSubmitState(form);
        } catch (err) {
            console.error('Submit failed', err);
            resetUploadSubmitState(form);
        }
    }

    if (bankAccountDocumentsUploadForm instanceof HTMLFormElement
        && bankAccountDocumentsUploadForm.dataset.beforeSubmitBound !== 'true') {
        bankAccountDocumentsUploadForm.addEventListener('sds:form:beforeSubmit', handleSepaUploadBeforeSubmit);
        bankAccountDocumentsUploadForm.dataset.beforeSubmitBound = 'true';
    }

    // For uploads with `max-files="1"` (and generally any sds-upload) the
    // drop label still invites clicking after capacity is reached. Disable
    // the underlying <input type="file"> and block clicks on the drop area
    // so the user cannot trigger a file picker that would only error out.
    //
    // NB: the <sds-upload> custom element is stripped by the TagHelper
    // (output.TagName = null); the rendered root is `<div class="upload"
    // data-upload-url="..." data-max-files="...">`. Select on a data attribute
    // that the TagHelper always sets on that root.
    const UPLOAD_ROOT_SELECTOR = '[data-upload-url][data-max-files]';

    const updateUploadCapacity = (uploadRoot) => {
        if (!uploadRoot) return;
        const max = Number(uploadRoot.dataset.maxFiles) || 1;
        const filled = uploadRoot.querySelectorAll('[data-upload-files] li.file').length;
        const atCapacity = filled >= max;

        const input = uploadRoot.querySelector('[data-upload-input]');
        const drop = uploadRoot.querySelector('[data-upload-drop]');
        const label = uploadRoot.querySelector('label.label');

        uploadRoot.dataset.atCapacity = String(atCapacity);
        if (input) input.disabled = atCapacity;
        if (drop) {
            drop.style.pointerEvents = atCapacity ? 'none' : '';
            drop.setAttribute('aria-disabled', String(atCapacity));
        }
        if (label) {
            label.style.pointerEvents = atCapacity ? 'none' : '';
        }
    };

    const refreshAllUploadCapacities = () => {
        document.querySelectorAll(UPLOAD_ROOT_SELECTOR).forEach(updateUploadCapacity);
    };

    iban1AndAndCheck?.addEventListener('change', handleIban1AndAndListener);
    iban2AndAndCheck?.addEventListener('change', handleIban2AndAndListener);
    iban1PercentageInput?.addEventListener('keydown', blockDecimalInput);
    iban1PercentageInput?.addEventListener('beforeinput', blockDecimalInput);
    iban1PercentageInput?.addEventListener('paste', handlePercentagePaste(iban1PercentageInput));
    iban1PercentageInput?.addEventListener("input", handleIban1PercentageInputListeners);
    iban1PercentageInput?.addEventListener("change", handleIban1PercentageInputListeners);
    iban1Name1Input?.addEventListener("input", updateSecondApplicantUploadItemVisibility);
    iban1Name1Input?.addEventListener("change", updateSecondApplicantUploadItemVisibility);
    iban2Name1Input?.addEventListener("input", updateSecondApplicantUploadItemVisibility);
    iban2Name1Input?.addEventListener("change", updateSecondApplicantUploadItemVisibility);
    iban2PercentageInput?.addEventListener('keydown', blockDecimalInput);
    iban2PercentageInput?.addEventListener('beforeinput', blockDecimalInput);
    iban2PercentageInput?.addEventListener('paste', handlePercentagePaste(iban2PercentageInput));
    iban2PercentageInput?.addEventListener("input", (event) => {
        sanitizePercentageInput(iban2PercentageInput);
        updatePercentages(event);
        updateSecondApplicantUploadItemVisibility();
    });
    iban2PercentageInput?.addEventListener("change", (event) => {
        sanitizePercentageInput(iban2PercentageInput);
        updatePercentages(event);
        updateSecondApplicantUploadItemVisibility();
    });

    // Initial visibility based on current checkbox state (e.g. after server-side re-render).
    if (iban1AndAndCheck) toggleBlockVisibility(iban1Name2Block, iban1AndAndCheck.checked);
    if (iban2AndAndCheck) toggleBlockVisibility(iban2Name2Block, iban2AndAndCheck.checked);
    updateSignedAllVisibility();
    updateSecondApplicantUploadItemVisibility();

    // sds-upload dispatches these custom events (bubbling) from Upload.js;
    // event.target is the rendered root div (the TagHelper strips <sds-upload>).
    const onUploadChange = (event) => {
        updateUploadButton();
        const target = event.target?.closest?.(UPLOAD_ROOT_SELECTOR);
        if (target) updateUploadCapacity(target);
    };
    document.addEventListener('sds-upload:file-added', onUploadChange);
    document.addEventListener('sds-upload:file-removed', onUploadChange);

    // Initial state (handles page reloads where files were already uploaded).
    updateUploadButton();
    refreshAllUploadCapacities();

    downloadSepaForm?.addEventListener('submit', handleDownloadSepaSubmit);

    // bfcache restore: when the user returns via Back, the disabled/loading
    // state from the previous submit is restored along with the DOM. Reset
    // it so the button is usable again.
    window.addEventListener('pageshow', (event) => {
        if (!event.persisted) return;
        sepaUploadSubmitInProgress = false;
        setDownloadingSepaState(false);
        setSubmittingState(false);
        updateUploadButton();
        refreshAllUploadCapacities();
    });
};
